import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { Tax } from '../models/Tax';
import { GlobalTaxResponse, TaxResponse } from '../models/TaxResponse';
import { TaxDeterminationService } from './tax-determination.http.service';
import { TaxRequest } from '../models/TaxRequest';

@Injectable()
export class TaxDeterminationStore {

  private taxesList: ReplaySubject<List<TaxResponse>> = new ReplaySubject<List<TaxResponse>>(1);
  private taxesVerified: ReplaySubject<List<TaxResponse>> = new ReplaySubject<List<TaxResponse>>(1);
  private globalResponseTaxesList: ReplaySubject<GlobalTaxResponse> = new ReplaySubject<GlobalTaxResponse>(1);

  constructor(
    private flashMessagesService: FlashMessagesService,
    private taxDeterminationService: TaxDeterminationService
  ) {
  }

  healthTDS(): Observable<boolean> {
    return this.taxDeterminationService.healthTDS()
      .catch((error: any) => {
        this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', `Error TDS Health: ${error}`);
        return Observable.throw(error);
      })
      .map((res: boolean) => {
        return res;
      });
  }

  loadTaxRates(eventId: number): Observable<any> {

    return this.taxDeterminationService.getTaxRate(eventId)
      .catch((error: any) => {
        if (error._body.includes('Unable to view Payment Page')) {
          this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', `Error in TaxRate  Health: ${error}`);
        } else {
          this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', `Error getting TaxRate: ${error}`);
        }
        return Observable.throw(error);
      })
      .map((res: GlobalTaxResponse) => {
        let validTax = true;
        if (res.taxResponses === null) {
          this.taxesList.next(List<TaxResponse>());
        } else {
          validTax = this.checkTaxResponseWithError(res.taxResponses);
          if (validTax) {
            this.taxesList.next(res.taxResponses);
          } else {
            // TODO: This is a temporary solution since the taxResponse should always be valid
            res.isValidTax = false;
            this.taxesList.next(List<TaxResponse>());
          }

        }
        this.globalResponseTaxesList.next(res);
        return res;
      });

  }

  // TODO: This is a temporary solution since the taxResponse should always be valid
  checkTaxResponseWithError(taxResponse: List<TaxResponse>): boolean {
    let validTax = true;
    taxResponse.map((tax: TaxResponse) => {
      if (Boolean(tax.status) === Boolean(0)
        || ( tax.supplier !== null
          && tax.supplier !== undefined
          && tax.supplier.countryCode !== 'US'
          && ( tax.taxes === null || tax.taxes === undefined || tax.taxes.length === 0)
           )
      ) {
        validTax = false;
      }
    });
    return validTax;
  }

  loadTaxRatesByParty(eventId: number, eventPartyId): Observable<any> {

    return this.taxDeterminationService.getTaxRateByParty(eventId, eventPartyId)
      .catch((error: any) => {
        if (error._body.includes('Unable to view Payment Page')) {
          this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', `Error in TaxRate  Health: ${error}`);
        } else {
          this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', `Error getting TaxRate: ${error}`);
        }
        return Observable.throw(error);
      })
      .map((res: GlobalTaxResponse) => {
        if (res.taxResponses === null) {
          this.taxesList.next(List<TaxResponse>());
        } else {
          this.taxesList.next(res.taxResponses);
        }
        this.globalResponseTaxesList.next(res);
        return res;
      });

  }

  verifyTaxRatesByParty(taxRequest: TaxRequest): Observable<any> {
    return this.taxDeterminationService.verifyTaxRate(taxRequest)
      .catch((error: any) => {
        if (error._body.includes('Unable to view Payment Page')) {
          this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', `Error in TaxRate  Health: ${error}`);
        } else {
          this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', `Error getting TaxRate: ${error}`);
        }
        return Observable.throw(error);
      })
      .map((res: GlobalTaxResponse) => {
        if (res.taxResponses === null) {
          this.taxesVerified.next(List<TaxResponse>());
        } else {
          this.taxesVerified.next(res.taxResponses);
        }
        this.globalResponseTaxesList.next(res);
        return res;
      });
  }

  getTaxRates(): Observable<List<TaxResponse>> {
    return this.taxesList.asObservable();
  }

  getGlobalResponseTaxesList(): Observable<GlobalTaxResponse> {
    return this.globalResponseTaxesList.asObservable();
  }

  vendorTaxRates(eventPartyId: number, applyOoiv: boolean): Observable<List<TaxResponse>> {
    if (applyOoiv) {
      return this.taxesList.map((filteredList: List<TaxResponse>) => {
        let filterReult = filteredList.filter((filtered: TaxResponse) =>
          filtered.eventPartyId === eventPartyId);
        return filterReult as List<TaxResponse>;
      });
    } else {
      const taxes = List<TaxResponse>([]);
      return Observable.of(taxes);
    }
  }

  getVendorCalculatedTaxes(eventPartyId: number, calculatedPaymentParty: number, applyOoiv: boolean): Observable<number> {
    const obs$ = this.vendorTaxRates(eventPartyId, applyOoiv);

    return obs$.map((list: List<TaxResponse>) => {
      const taxTotal = list.reduce((sum: number, vendorTax: TaxResponse) => {

        return sum + vendorTax.taxes.reduce((sumTax: number, vtax: Tax) => {
          return sumTax + (vtax.rate * calculatedPaymentParty) / 100;
        }, 0);

      }, 0);
      return taxTotal;
    });

  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/tax-determination.store.ts